'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../../../styles/templates/customers/register.scss');